import React, { useEffect, useRef } from 'react';
import { Box, Container, SxProps, Theme } from '@mui/material';
import StaticInfo from 'components/common/StaticInfo';

export default function SelectionErrorMessage({ label, sx }: { label: string; sx?: SxProps<Theme> }) {
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, []);

    return (
        <Box ref={ref} sx={sx}>
            <Container
                className={'mi-container-3 form-container--maxfull'}
                maxWidth={false}
                component="main"
                disableGutters={true}
            >
                <StaticInfo label={label} align={'center'} type={'error'} />
            </Container>
        </Box>
    );
}
